(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7109],{

/***/ 85251:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/[category]/[slug]",
      function () {
        return __webpack_require__(20723);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* reexport */ PageContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/atomic/PageContainer/PageContainer.tsx

var PageContainer = function(param) {
    var children = param.children, _containerClass = param.containerClass, containerClass = _containerClass === void 0 ? "" : _containerClass;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
        className: "container container--body ".concat(containerClass),
        children: children
    });
};

;// CONCATENATED MODULE: ./components/atomic/PageContainer/index.ts



/***/ }),

/***/ 52488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* reexport */ Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./components/styleguide/Link/index.ts + 1 modules
var Link = __webpack_require__(63383);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/styleguide/Breadcrumbs/breadcrumbs.module.scss
var breadcrumbs_module = __webpack_require__(11783);
var breadcrumbs_module_default = /*#__PURE__*/__webpack_require__.n(breadcrumbs_module);
;// CONCATENATED MODULE: ./components/styleguide/Breadcrumbs/Breadcrumbs.tsx







var Icon = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8075), __webpack_require__.e(9878), __webpack_require__.e(1490)]).then(__webpack_require__.bind(__webpack_require__, 56244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56244)
            ];
        }
    }
});
var Breadcrumbs = function(param) {
    var crumbs = param.crumbs, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: "".concat((breadcrumbs_module_default()).main, " ").concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
            className: (breadcrumbs_module_default()).crumbs,
            children: [
                crumbs.length > 1 && crumbs.slice(0, crumbs.length - 1).map(function(crumb) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (breadcrumbs_module_default()).crumb,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* InternalLink */.h, {
                            icon: crumb.icon,
                            href: crumb.slug,
                            hierarchy: Button/* ButtonHierarchy.Borderless */.B.Borderless,
                            size: system/* Size.Small */.$u.Small,
                            children: crumb.label
                        })
                    }, crumb.slug);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    className: "".concat((breadcrumbs_module_default()).crumb, " ").concat((breadcrumbs_module_default()).current),
                    "aria-current": "page",
                    children: [
                        crumbs[crumbs.length - 1].icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                            name: crumbs[crumbs.length - 1].icon,
                            size: system/* Size.Small */.$u.Small
                        }),
                        crumbs[crumbs.length - 1].label
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Breadcrumbs/index.ts



/***/ }),

/***/ 65299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* reexport */ ChatWidget; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./lib/utilities/system.js + 1 modules
var system = __webpack_require__(70591);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./components/styleguide/ChatWidget/ChatWidget.tsx



var ChatWidget = function() {
    if (!(0,system/* isProd */.BB)() || !"0e82ae7a-23e7-4571-a768-93f6cea963b2") {
        return false;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        id: "ze-snippet",
        strategy: "lazyOnload",
        src: "https://static.zdassets.com/ekr/snippet.js?key=".concat("0e82ae7a-23e7-4571-a768-93f6cea963b2")
    });
};

;// CONCATENATED MODULE: ./components/styleguide/ChatWidget/index.ts



/***/ }),

/***/ 77926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* reexport */ SearchFormCTA; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/views/SearchForm/index.ts + 1 modules
var SearchForm = __webpack_require__(18412);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./components/views/SearchFormCTA/search-form-cta.module.scss
var search_form_cta_module = __webpack_require__(32069);
var search_form_cta_module_default = /*#__PURE__*/__webpack_require__.n(search_form_cta_module);
;// CONCATENATED MODULE: ./components/views/SearchFormCTA/SearchFormCTA.tsx




var SearchFormCTA = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (search_form_cta_module_default()).main,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (search_form_cta_module_default()).content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: (search_form_cta_module_default()).title,
                    children: "Quickly search all the big leasing sites"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchForm/* SearchForm */.U, {
                    initialVehicleType: constants/* FILTER_VEHICLE_TYPES_CARS */.DC
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/views/SearchFormCTA/index.ts



/***/ }),

/***/ 54767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OZ": function() { return /* binding */ getGuideCategoryName; },
/* harmony export */   "VI": function() { return /* binding */ getTrustpilotStarRating; },
/* harmony export */   "of": function() { return /* binding */ getTrustpilotLabel; },
/* harmony export */   "rC": function() { return /* binding */ isVowel; }
/* harmony export */ });
/* unused harmony exports getGuideCategoryType, getReviewHeading */
var getGuideCategoryName = function(urlKey) {
    switch(urlKey){
        case "personal-car-leasing":
            return "Personal Car Leasing";
        case "contracts-and-finance":
            return "Contracts & Finance";
        case "business-car-leasing":
            return "Business Car Leasing";
        case "hybrid-and-electric-leasing":
            return "Hybrid & Electric Leasing";
        case "van-leasing-guide":
            return "Van Leasing";
        case "leasing-with-leaseloco":
            return "Leasing With LeaseLoco";
        default:
            return "LeaseLoco Guide";
    }
};
var getGuideCategoryType = function(urlKey) {
    switch(urlKey){
        case "personal-car-leasing":
            return "GUIDE_PERSONAL";
        case "contracts-and-finance":
            return "GUIDE_CONTRACTS_FINANCE";
        case "business-car-leasing":
            return "GUIDE_BUSINESS";
        case "hybrid-and-electric-leasing":
            return "GUIDE_ELECTRIC";
        case "van-leasing-guide":
            return "GUIDE_VAN";
        case "leasing-with-leaseloco":
            return "GUIDE_LEASELOCO";
        default:
            return "GUIDE_LEASING";
    }
};
var getReviewHeading = function(text) {
    switch(text){
        case "tenSecondReview":
            return "Ten second review";
        case "background":
            return "Background";
        case "designAndBuild":
            return "Design and build";
        case "marketAndModel":
            return "Market and model";
        case "costOfOwnership":
            return "Cost of ownership";
        case "summary":
            return "Summary";
        default:
            return text;
    }
};
var isVowel = function(letter) {
    return letter === "A" || letter === "E" || letter === "I" || letter === "O" || letter === "U";
};
var getTrustpilotStarRating = function(rating) {
    if (rating >= 1 && rating <= 1.2) {
        return 1;
    }
    if (rating >= 1.3 && rating <= 1.7) {
        return 1.5;
    }
    if (rating >= 1.8 && rating <= 2.2) {
        return 2;
    }
    if (rating >= 2.3 && rating <= 2.7) {
        return 2.5;
    }
    if (rating >= 2.8 && rating <= 3.2) {
        return 3;
    }
    if (rating >= 3.3 && rating <= 3.7) {
        return 3.5;
    }
    if (rating >= 3.8 && rating <= 4.2) {
        return 4;
    }
    if (rating >= 4.3 && rating <= 4.7) {
        return 4.5;
    }
    if (rating >= 4.8 && rating <= 5) {
        return 5;
    }
    return rating;
};
var getTrustpilotLabel = function(rating) {
    if (rating >= 1 && rating <= 1.7) {
        return "Bad";
    }
    if (rating >= 1.8 && rating <= 2.7) {
        return "Poor";
    }
    if (rating >= 2.8 && rating <= 3.7) {
        return "Average";
    }
    if (rating >= 3.8 && rating <= 4.2) {
        return "Great";
    }
    if (rating >= 4.3 && rating <= 5) {
        return "Excellent";
    }
    return rating;
};


/***/ }),

/***/ 20723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ GuidesArticlePage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28734);
/* harmony import */ var dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _components_atomic_PageContainer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29099);
/* harmony import */ var _components_atomic_PageMetaData__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1429);
/* harmony import */ var _components_styleguide_Breadcrumbs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52488);
/* harmony import */ var _components_styleguide_ChatWidget__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65299);
/* harmony import */ var _components_styleguide_Header__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(638);
/* harmony import */ var _components_views_SearchFormCTA__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(77926);
/* harmony import */ var _lib_routes__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7158);
/* harmony import */ var _lib_utilities_page__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(54767);













var ContentPageBody = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8456), __webpack_require__.e(6310), __webpack_require__.e(6388), __webpack_require__.e(250)]).then(__webpack_require__.bind(__webpack_require__, 60250));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60250)
            ];
        }
    }
});
var __N_SSP = true;
function GuidesArticlePage(param) {
    var article = param.article, guideCategoryKey = param.guideCategoryKey;
    dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_2___default()));
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (typeof window.ttq !== "undefined") {
            window.ttq.track("ViewContent", {
                /* eslint-disable */ content_id: "".concat(article.content.title),
                content_type: "product",
                content_name: "".concat(article.content.title),
                /* eslint-enable */ quantity: 1,
                value: null,
                price: null,
                currency: "GBP"
            });
        }
    }, [
        article.content.title
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atomic_PageMetaData__WEBPACK_IMPORTED_MODULE_6__/* .PageMetaData */ .S, {
                title: "".concat(article.content.title, " | LeaseLoco"),
                pageTitle: "".concat(article.content.title, " | LeaseLoco"),
                description: article.content.metaDescription ? article.content.metaDescription : article.content.description.replace(/<[^>]*>?/gm, ""),
                pageUrl: "/guides/".concat(guideCategoryKey, "/").concat(article.urlKey),
                image: article.content.thumbnail,
                blogArticle: article.content
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_ChatWidget__WEBPACK_IMPORTED_MODULE_8__/* .ChatWidget */ .A, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Header__WEBPACK_IMPORTED_MODULE_9__/* .Header */ .h, {
                backgroundColor: "white",
                backButtonUrl: "/guides/".concat(guideCategoryKey)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_atomic_PageContainer__WEBPACK_IMPORTED_MODULE_5__/* .PageContainer */ ._, {
                containerClass: "container--blog-article",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Breadcrumbs__WEBPACK_IMPORTED_MODULE_7__/* .Breadcrumbs */ .O, {
                        crumbs: [
                            {
                                label: "Home",
                                slug: _lib_routes__WEBPACK_IMPORTED_MODULE_11__/* .ROUTES.homePage.url */ .Z.homePage.url
                            },
                            {
                                label: "Leasing Guides",
                                slug: _lib_routes__WEBPACK_IMPORTED_MODULE_11__/* .ROUTES.guidesPage.url */ .Z.guidesPage.url
                            },
                            {
                                label: "".concat((0,_lib_utilities_page__WEBPACK_IMPORTED_MODULE_12__/* .getGuideCategoryName */ .OZ)(guideCategoryKey)),
                                slug: "/guides/".concat(guideCategoryKey)
                            },
                            {
                                label: article.content.title,
                                slug: null
                            }, 
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContentPageBody, {
                        article: article
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_views_SearchFormCTA__WEBPACK_IMPORTED_MODULE_10__/* .SearchFormCTA */ .g, {})
        ]
    });
}


/***/ }),

/***/ 11783:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"breadcrumbs_main__VBByA","crumbs":"breadcrumbs_crumbs__pJ96J","crumb":"breadcrumbs_crumb__NOO8e","phAnimation":"breadcrumbs_phAnimation__MNg6t"};

/***/ }),

/***/ 32069:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"search-form-cta_main__BGo2t","content":"search-form-cta_content__8vx7u","title":"search-form-cta_title__0B4VG","phAnimation":"search-form-cta_phAnimation__Df6yh"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1852,7144,1967,8611,2580,638,1429,9047,9774,2888,179], function() { return __webpack_exec__(85251); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);